import { track } from '@/common/monitoring/heap';

const baseHeapData: Record<string, any> = {
  eventType: 'OrderCard',
  eventLabel: 'FindTicketsOrderCard',
};

export const trackEvent = (eventName: string, eventAction: string) => {
  track({
    eventName,
    eventData: { ...baseHeapData, eventAction },
  });
};
